module.exports = __webpack_public_path__ + "img/none.7c515969.png";